module.exports = __webpack_public_path__ + "08ee51698272a28f8a1e5f8ba0bec894.svg";